// IMPORT
    // MODULE(S)
        import React from 'react';
        import ReactDOM from 'react-dom';
    // STYLE(S)
        import './styles/index.css';
    // COMPONENT(S)
        import App from './components/App';



// MAIN CONTENT - STARTING FUNCTION
    ReactDOM.render(
        <App />,
        document.getElementById('root')
    );
